import { useState } from 'react'

const round = (n: number) => Math.round(n * 1000) / 1000

// The phone's position, asked for only when the pilot taps "nearest" --
// never on page load. Rounded to three decimals (about 100 m): plenty to
// sort airfields by, and it keeps the query key stable while they stand
// still.
export function useNearMe(onDenied: () => void) {
  const [position, setPosition] = useState<{ lat: number; lon: number } | null>(null)
  const [locating, setLocating] = useState(false)

  const toggle = () => {
    if (position) {
      setPosition(null)
      return
    }
    if (!('geolocation' in navigator)) {
      onDenied()
      return
    }
    setLocating(true)
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocating(false)
        setPosition({ lat: round(pos.coords.latitude), lon: round(pos.coords.longitude) })
      },
      () => {
        setLocating(false)
        onDenied()
      },
      { enableHighAccuracy: false, timeout: 15_000, maximumAge: 60_000 },
    )
  }

  return { position, locating, toggle }
}
